import Module from 'mini-module-switcher/lib/schema/Module';
import switchModule from 'owa-mail-store/lib/actions/switchModule';
import {
    SettingsSubRoutes,
    SettingsCategoryOption,
} from 'mini-options-view/lib/schema/SettingsSubRoutes';

/**
 * Adding an extra settingsCategoryOption as a stop gap to support the new advertising sub route option
 * Not investing much to clean this up as we will be migrating to react-router
 * @param params
 */
export default function optionsModuleRouterHandler(params: {
    subRoute?: SettingsSubRoutes;
    subRouteOption?: SettingsCategoryOption;
}) {
    switchModule(Module.Options, params.subRoute, params.subRouteOption);
}
